
import React from 'react';

import './Product.css';
import { BsCartDash } from 'react-icons/bs';

const Product = (props) => {
    // console.log(props.product);
    const { name, img, price, Description, seller } = props.product;
    return (
        <div className='col-12 products ' style={{ height: '42rem' }}>
            <>
                <img src={img} alt="" className=' mb-4 img-fluid ' />
                <h4>{name.slice(0, 30)}</h4>
                <h4>Price:  $ {price}</h4>
                <h6>Manufactured:  {seller}</h6>
                <small className='text-justify'> <code>Description:</code> {Description.slice(0, 120)}...</small>

                <span onClick={() => props.handdleAddRoCart(props.product)} className=' btn btn-outline-dark  button '> Add To Cart <BsCartDash className='ms-lg-2 ms-0 fw-bold'></BsCartDash> </span>
            </>

        </div>
    );
};

export default Product;